import {
  DEBUG_MODE,
  IS_PRODUCTION,
  KIOSK_CHROME_EXTENSION_ID_ON_PRODUCTION_DEVICES,
  KIOSK_CHROME_EXTENSION_ID_IN_LOCAL_CHROME_BROWSER,
} from './config'

export function callKioskExtension(method: any) {
  try {
    return new Promise((resolve) => {
      try {
        if (!IS_PRODUCTION) resolve(null)
        else {
          //@ts-ignore
          chrome.runtime.sendMessage(
            IS_PRODUCTION
              ? KIOSK_CHROME_EXTENSION_ID_ON_PRODUCTION_DEVICES
              : KIOSK_CHROME_EXTENSION_ID_IN_LOCAL_CHROME_BROWSER,
            {
              methodName: method,
            },
            null,
            (response: any) => {
              resolve(response)
            }
          )
        }
      } catch (ee: any) {
        if (DEBUG_MODE) console.log(ee)
        resolve(null)
      }
    })
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
    return null
  }
}
